import React from 'react';
import './About1.css';
import { Link } from 'react-router-dom';
// import img31 from '../../assets/img31.jpg';
import a2 from '../../assets/a2.jpg'; 
import a8 from '../../assets/a8.jpg';
import { FaCheck} from 'react-icons/fa';

// <FaCheck />          // plain check
// <FaCheckCircle />    // circular check
// <FaCheckSquare />    // square check



const About1 = () => {

  return (
    <section className="about-section1" >
      <div className="about-container1">
        <div className="about-left1">
          {/* <img src={img31} alt="Umbrella Icon" className="umbrella-icon" /> */}
          <div className="image-stack">
            <img src={a2} alt="Family" className="main-img" />
            <img src={a8} alt="Elderly" className="overlay-img" />
          </div>
        </div>
        <div className="about-right1">
          <h5 className="section-label">PSJ Capital Ventures</h5>
          
          
          <ul className="features-list">
            <li> <FaCheck /> WHO WE ARE</li>
            <p>-	We’re not here to chase trends. We’re here to steward legacies.<br></br>
-	87% of ultra-HNIs say long-term relationships with advisors matter more than quick returns. At PSJ Capital Ventures, our strength lies in consistency. <br></br>
-	We’re not just about products - we’re built on trust
</p>
            <li> <FaCheck />  WHAT WE DO</li>
            <p>- Your wealth journey is uniquely yours, and so is the strategy behind it.<br></br>
- We build plans that integrate purpose, performance, and peace of mind, not just numbers.
</p>
            <li> <FaCheck />  WHO WE SERVE</li>
            <p>Whether you're scaling a startup, running a family business, or chasing a dream, we manage the money behind your mission.</p>
            <li> <FaCheck />  OUR PROMISE</li>
            <p>We skip the complex process. You get straight answers since day 1.
Because smart decisions begin with sharp understanding.
</p>
          </ul>
          <div className="buttons">
            <Link to='/contact'><button className="btn-contact">Contact With Us</button></Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About1;
